import { parse, isValid as isValidDate } from "date-fns";

/**
 * Helper function to parse API date format hint
 * Converts format hints like "mm/dd/yyyy HH:MM" to date-fns format "MM/dd/yyyy"
 */
export var parseApiFormat = function parseApiFormat(apiFormat) {
  if (!apiFormat) return null;
  var datePart = apiFormat.split(" ")[0];
  return datePart.replace(/mm/g, "MM");
};

/**
 * Helper function to get the date format for a field
 * Uses the same logic as DateInput component to ensure consistent parsing
 */
export var getDateFormat = function getDateFormat(fieldSchemas, fieldName) {
  var _field$metadata;
  var field = fieldSchemas.find(function (f) {
    return f.field_name === fieldName;
  });
  var formatHint = field === null || field === void 0 || (_field$metadata = field.metadata) === null || _field$metadata === void 0 ? void 0 : _field$metadata.format_hint;
  return parseApiFormat(formatHint) || process.env.NEXT_PUBLIC_REGIONAL_DATE_FORMAT || "MM/dd/yyyy";
};

/**
 * Helper function to safely parse a date string using the correct format
 * Returns null if the date is invalid
 */
export var parseDateSafely = function parseDateSafely(dateString, dateFormat) {
  try {
    var parsedDate = parse(String(dateString).trim(), dateFormat, new Date());
    return isValidDate(parsedDate) ? parsedDate : null;
  } catch (e) {
    return null;
  }
};